<style scoped lang="less">
.rate-date {
    width: 100%;
    display: flex;
    flex-direction: column;
    .item {
        margin-bottom: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        .date {
            width: 200px;
        }
        .days {
            margin-left: 10px;
            width: 150px;
        }
        .money {
            margin-left: 10px;
            width: 200px;
        }
    }
}
.desc {
    font-size: 18px;
    line-height: 30px;
}
</style>

<template>
    <el-dialog fullscreen :visible.sync="show" title="添加/修改" :close-on-press-escape="false">
        <el-form size="mini" label-width="100px" v-if="model">
            <el-form-item label="客户">
                <div class="line-container">
                    <el-input style="width:350px" v-model="user" disabled></el-input>
                    <el-button class="margin-l" type="primary" @click.stop="chooseItem('user')">选择</el-button>
                    <el-button class="margin-l" type="danger" icon="el-icon-delete" circle @click.stop="removeItem('user')"></el-button>
                </div>
            </el-form-item>
            <el-form-item label="产品">
                <div class="line-container">
                    <el-input style="width:350px" v-model="good" disabled></el-input>
                    <el-button class="margin-l" type="primary" @click.stop="chooseItem('good')">选择</el-button>
                    <el-button class="margin-l" type="danger" icon="el-icon-delete" circle @click.stop="removeItem('good')"></el-button>
                    <el-button class="margin-l" type="primary" @click.stop="save" :loading="loadingSave">保存</el-button>
                </div>
            </el-form-item>
            <el-form-item label="理财顾问姓名">
                <el-input v-model="model.advisorName" placeholder="不填->不显示；都填，客户可直接看到"></el-input>
            </el-form-item>
            <el-form-item label="理财顾问电话">
                <el-input v-model="model.advisorPhone"></el-input>
            </el-form-item>
            <el-form-item label="产品分类">
                <el-radio-group v-model="model.goodCategory">
                    <el-radio-button label="城投债"></el-radio-button>
                    <el-radio-button label="信托"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="银行">
                <el-input v-model="model.bank"></el-input>
            </el-form-item>
            <el-form-item label="户名">
                <el-input v-model="model.bankUsername"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号">
                <el-input v-model="model.bankCard"></el-input>
            </el-form-item>
            <el-form-item label="投资金额(万)">
                <el-input-number @change="amountChange" v-model="amount" :min="1" :step="1"></el-input-number>
            </el-form-item>
            <el-form-item label="产品期限(月)">
                <el-input-number v-model="model.term" @change="calcEndDate" :min="1" :step="1"></el-input-number>
            </el-form-item>
            <el-form-item label="业绩基准(%)">
                <el-input-number v-model="model.rate" :min="0" :step="0.1" :precision="2"></el-input-number>
            </el-form-item>
            <el-form-item label="付息方式">
                <el-radio-group v-model="model.payMethod">
                    <el-radio-button label="季度付息"></el-radio-button>
                    <el-radio-button label="半年付息"></el-radio-button>
                    <el-radio-button label="按年付息"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="打款时间">
                <el-date-picker v-model="model.paymentDate" type="date"></el-date-picker>
            </el-form-item>
            <el-form-item label="成立时间">
                <el-date-picker v-model="model.startDate" @change="calcEndDate" type="date"></el-date-picker>
            </el-form-item>
            <el-form-item label="到期时间">
                <el-date-picker v-model="model.endDate" type="date"></el-date-picker>
            </el-form-item>
            <el-form-item label="计息日">
                <el-input-number v-model="model.rateDay" :min="1" :max="31" :step="1"></el-input-number>
                <template v-if="model.rateDay && model.startDate && model.endDate && model.term && model.amount && model.rate && model.payMethod">
                    <el-button class="margin-l" size="mini" type="primary" @click.stop="calcRateDate()">智能生成</el-button>
                    <span class="margin-l color-danger">每次修改投资额记得重新生成计息明细！</span>
                    <el-button class="margin-l" size="mini" type="success" @click.stop="addRateDate()">加一行</el-button>
                </template>
            </el-form-item>
            <el-form-item label="计息明细" v-if="rateDates.length">
                <div class="rate-date">
                    <div class="item" v-for="(item,index) in rateDates">
                        <el-date-picker class="date" @change="rateDateChange(index)" v-model="item.date" type="date"></el-date-picker>
                        <el-input class="days" v-model="item.days" disabled>
                            <template slot="prepend">存续天数</template>
                        </el-input>
                        <el-input class="money" v-model="item.money" disabled>
                            <template slot="prepend">计息金额</template>
                        </el-input>
                        <el-button @click.stop="removeRateDatesItem(index)" class="margin-l" type="danger" icon="el-icon-delete" circle></el-button>
                    </div>
                    <div>本息合计：{{calcTotal()}}</div>
                </div>
            </el-form-item>
            <div class="desc">通常情况下：一年存续天数为365天，2年为730天，3年为1095天。</div>
            <div class="desc color-danger">请注意检查金额、收益、期限是否填写正确。</div>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.stop="show = false" plain>取 消</el-button>
            <el-button type="primary" @click.stop="save" :loading="loadingSave">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { HttpClient } from "../../util/http.js";
import { msgError, msgSuccess } from "../../util/toast";

import { loginState } from "../../util/login";
import { selectAdminUser, selectGood } from "../../util/event.js";

export default {
    components: {},
    data() {
        return {
            loadingSave: false,
            show: false,
            model: null,
            rateDates: [], //付息日 数组
            amount: 1,
        };
    },
    computed: {
        user() {
            if (this.model.user) {
                return (
                    (this.model.user.name ? this.model.user.name : "(未命名)") +
                    " - " +
                    (this.model.user.nickname
                        ? this.model.user.nickname
                        : "(无昵称)") +
                    " - " +
                    (this.model.user.phone ? this.model.user.phone : "(无电话)")
                );
            } else {
                return "";
            }
        },
        good() {
            if (this.model.good) {
                return (
                    (this.model.good.title
                        ? this.model.good.title
                        : "(未命名)") +
                    " - " +
                    (this.model.good.timeLimit
                        ? this.model.good.timeLimit
                        : "(未录入期限)")
                );
            } else {
                return "";
            }
        },
        //日息
        dailyRate() {
            return this.model.amount && this.model.rate
                ? (this.model.amount * this.model.rate) / 100 / 365
                : 0;
        },
    },
    created() {},
    mounted() {},
    methods: {
        calcTotal() {
            let days = 0;
            let money = 0;
            if (this.rateDates && this.rateDates.length) {
                this.rateDates.forEach((it) => {
                    days += it.days;
                    money += parseFloat(it.money);
                });
            }
            return days + "天    " + money.toFixed(2) + "元";
        },
        amountChange() {
            if (this.amount) {
                this.model.amount = this.amount * 10000;
            }
        },
        calcRateDate() {
            if (this.model.rateDay) {
                let years = Math.ceil(this.model.term / 12) + 1; //term 期限（多少个月）
                let months = 0; //一年里几次付息
                if (this.model.payMethod == "季度付息") {
                    months = 4;
                } else if (this.model.payMethod == "半年付息") {
                    months = 2;
                } else if (this.model.payMethod == "按年付息") {
                    months = 1;
                }
                let rateDateArray = [];
                for (let i = 0; i < years; i++) {
                    let year = dayjs(this.model.startDate)
                        .add(i, "year")
                        .format("YYYY");
                    for (let j = 0; j < months; j++) {
                        let month = (12 / months) * (j + 1);
                        let day = this.model.rateDay;
                        rateDateArray.push(
                            dayjs(year + "-" + month + "-" + day).format(
                                "YYYY-MM-DD"
                            )
                        );
                    }
                }
                this.rateDates.splice(0, this.rateDates.length);
                for (let i = 0; i < rateDateArray.length; i++) {
                    const day = rateDateArray[i];
                    let bigThanStartDate = dayjs(day).diff(
                        dayjs(this.model.startDate),
                        "day"
                    );
                    let smallThanEndDate = dayjs(this.model.endDate).diff(
                        dayjs(day),
                        "day"
                    );
                    if (bigThanStartDate > 0 && smallThanEndDate >= 0) {
                        this.rateDates.push({
                            date: day,
                            days: 0,
                            money: 0,
                        });
                    }
                }
                //到期日
                if (
                    this.rateDates.length &&
                    dayjs(this.model.endDate).diff(
                        dayjs(this.rateDates[this.rateDates.length - 1].date),
                        "day"
                    ) > 0
                ) {
                    this.rateDates.push({
                        date: this.model.endDate,
                        days: 0,
                        money: 0,
                    });
                }
                for (let i = 0; i < this.rateDates.length; i++) {
                    this.rateDateChange(i);
                }
            }
        },
        rateDateChange(index) {
            this.rateDates[index].days =
                index == 0
                    ? dayjs(this.rateDates[index].date).diff(
                          dayjs(this.model.startDate),
                          "day"
                      )
                    : dayjs(this.rateDates[index].date).diff(
                          dayjs(this.rateDates[index - 1].date),
                          "day"
                      );
            let money = this.rateDates[index].days * this.dailyRate;
            if (index == this.rateDates.length - 1) {
                money += this.model.amount;
            }
            this.rateDates[index].money = money.toFixed(2);
        },
        calcEndDate() {
            if (this.model.startDate && this.model.term) {
                this.$set(
                    this.model,
                    "endDate",
                    dayjs(this.model.startDate)
                        .add(this.model.term, "month")
                        .format("YYYY-MM-DD")
                );
            }
        },
        removeRateDatesItem(index) {
            if (index < this.rateDates.length - 1) {
                this.rateDates[index + 1].days += this.rateDates[index].days;
                this.rateDates[index + 1].money = (
                    parseFloat(this.rateDates[index + 1].money) +
                    parseFloat(this.rateDates[index].money)
                ).toFixed(2);
            } else if (
                index == this.rateDates.length - 1 &&
                this.rateDates.length > 1
            ) {
                this.rateDates[index - 1].money = (
                    parseFloat(this.rateDates[index - 1].money) +
                    parseFloat(this.model.amount)
                ).toFixed(2);
            }
            this.rateDates.splice(index, 1);
        },
        addRateDate() {
            this.rateDates.push({
                date: null,
                days: 0,
                money: 0,
            });
        },
        async chooseItem(key) {
            if (key == "user") {
                let item = await selectAdminUser();
                this.$set(this.model, key, item);
            } else if (key == "good") {
                let item = await selectGood();
                this.$set(this.model, key, item);
            }
        },
        removeItem(key) {
            this.$set(this.model, key, null);
        },
        addOrEdit(item) {
            this.rateDates = [];
            this.amount = 1;

            this.show = true;
            this.model = this.deepCopy({
                ...item,
            });
            if (this.model && this.model.rateDates) {
                this.rateDates = JSON.parse(this.model.rateDates);
            }
            if (this.model && this.model.amount) {
                this.amount = this.model.amount / 10000;
            }
        },
        async save() {
            if (this.amount) {
                this.model.amount = this.amount * 10000;
            }
            if (
                !this.model.user ||
                !this.model.good ||
                !this.model.bank ||
                !this.model.bankCard ||
                !this.model.amount ||
                !this.model.term ||
                !this.model.rate ||
                !this.model.payMethod ||
                !this.model.paymentDate ||
                !this.model.startDate ||
                !this.model.rateDay ||
                !this.model.endDate ||
                !this.rateDates.length
            ) {
                return msgError("操作失败！请检查输入");
            }
            let isNullRateDates = false;
            for (let i = 0; i < this.rateDates.length; i++) {
                const item = this.rateDates[i];
                if (!item.date) {
                    isNullRateDates = true;
                }
            }
            if (isNullRateDates) {
                return msgError("操作失败！请检查计息日");
            }
            this.loadingSave = true;
            await HttpClient.post("/order/add", {
                ...this.model,
                rateDates: JSON.stringify(this.rateDates),
            });
            msgSuccess();
            this.show = false;
            this.loadingSave = false;
            this.$emit("fetch-data");
        },
        //深拷贝
        deepCopy(obj) {
            if (obj == null) {
                return null;
            }
            if (Array.isArray(obj)) {
                //如果是数组
                const myArray = [];
                for (let i = 0; i < obj.length; i++) {
                    myArray.push(this.deepCopy(obj[i]));
                }
                return myArray;
            } else if (typeof obj == "object") {
                //如果是对象
                const myObject = {};
                for (let key in obj) {
                    myObject[key] = this.deepCopy(obj[key]);
                }
                return myObject;
            }
            return obj;
        },
    },
};
</script>

        